export default class DesignerHelper {
    constructor() {
        let assetsPrefix = process.env.NODE_ENV === 'development' ? 'dev.' : '';

        this.imagePath = `https://${assetsPrefix}assets.viralstyle.com/product-images/`;
        this.googleFonts = {
            'stylesheet': 'Exo|Goudy+Bookletter+1911|Graduate|Linden+Hill|Lobster|Lora|Montserrat|Nosifer|Oswald|Pacifico|Permanent+Marker|Roboto+Slab',
            styles: [
                {name: "Exo", style: "'Exo', sans-serif"},
                {name: 'Goudy Bookletter 1911', style: "'Goudy Bookletter 1911', serif"},
                {name: 'Graduate', style: "'Graduate', cursive"},
                {name: "Linden Hill", style: "'Linden Hill', serif"},
                {name: "Lobster", style: "'Lobster', cursive"},
                {name: 'Lora', style:"'Lora', serif"},
                {name: 'Montserrat', style: "'Montserrat', sans-serif"},
                {name: 'Nosifer',style:"'Nosifer', cursive"},
                {name: 'Oswald', style: "'Oswald', sans-serif"},
                {name: 'Pacifico', style: "'Pacifico', cursive"},
                {name: 'Permanent Marker', style: "'Permanent Marker', cursive"},
                {name: 'Roboto Slab', style: "'Roboto Slab', serif"}
            ]
        };
        this.textColors = '[{"color":"000080","title":"navy"},{"color":"000000","title":"black"},{"color":"D2691E","title":"Chocolate"},{"color":"7FFF00","title":"Chartreuse"},{"color":"FF0000","title":"Red"},{"color":800000,"title":"Maroon"},{"color":"FFFFFF","title":"White"},{"color":"0000FF","title":"Blue"},{"color":"FFFF00","title":"Yellow"},{"color":"FFA500","title":"Orange"},{"color":"00008B","title":"Dark Blue"},{"color":"8B0000","title":"Dark Red"},{"color":"FF4500","title":"Orange Red"},{"color":"FF8C00","title":"Dark Orange"},{"color":"008B8B","title":"Dark Cyan"},{"color":"9400D3","title":"Dark Violet"},{"color":"006400","title":"Dark Green"},{"color":"A9A9A9","title":"Dark Gray"},{"color":"9932CC","title":"Dark Orchid"},{"color":"ADFF2F","title":"Green Yellow"},{"color":"FF00FF","title":"Magenta"},{"color":"BC8F8F","title":"Rosy Brown"},{"color":"A0522D","title":"Sienna"},{"color":"B0C4DE","title":"Light steel Blue"},{"color":"9370DB","title":"Medium Purple"},{"color":"F5F5F5","title":"White Smoke"},{"color":"2E8B57","title":"Sea Green"},{"color":"FAFAD2","title":"Light Goldenrod Yellow"},{"color":"F0E68C","title":"Khaki"},{"color":"FFFAFA","title":"Snow"},{"color":"0000CD","title":"Medium Blue"},{"color":"00FF00","title":"Lime"},{"color":"00FA9A","title":"Medium Spring Green"},{"color":"FFE4E1","title":"Misty Rose"},{"color":"8B4513","title":"Saddle Brown"},{"color":"B22222","title":"Fire Brick"},{"color":"556B2F","title":"Dark Olive Green"},{"color":"4B0082","title":"Indigo"},{"color":"FF69B4","title":"Hot Pink"}]';
        this.googleFontsKey = process.env.NODE_ENV === 'development' ? 'AIzaSyAwdv84sSTlpUuf8VUdmlOuomLUbgLhQlQ' : 'AIzaSyCjS38w1kAfU2ECAxBCtqjOaBF45mDbIUo';
    }

    radDeg(rad) {
        var v = parseFloat(rad);
        var deg = (v * 180) / Math.PI;

        if (deg < 0) deg = 360 + deg;
        return Math.round(deg);
    };

    px(value) {
        if (value == '' && value == 0) return 0;
        if (typeof value == 'number' && value > 0) return value;
        if (value.indexOf('px') != -1) {
            var px = value.replace('px', '');
        }
        var px = parseInt(value);
        return Math.round(px);
    };

    sortColors(colors) {
        for (var i = 0; i < colors.length; i++) {
            var currentColor = new tinycolor(colors[i].hex);
            colors[i].hsl = currentColor.toHsl();
        }
        return colors.sort(function (a, b) {
            // return a.hsl.l - b.hsl.l;
            return (b.hsl.l - a.hsl.l === 0) ? (b.hsl.hue - a.hsl.hue) : b.hsl.l - a.hsl.l;
        });
    };
}


// WEBPACK FOOTER //
// ./app/assets/js/client-admin/designer/services/DesignerHelper.js